module.exports = __webpack_public_path__ + "img/lake-cabins.6a8ff7ce.jpg";